import "./assets/js/nav-pills.js";

export default {
  install() {
    // This plugin is used to import global assets
  }
};
